import React from "react";
import { Heart } from "lucide-react";
import { ATLETICA } from "../../data/content";
import Reveal from "./Reveal";

export const Atletica = () => (
  <section id="atletica" data-testid="atletica-section" className="bg-white py-20 md:py-32">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
      <div className="max-w-3xl mb-12">
        <Reveal>
          <p className="font-sub uppercase tracking-[0.3em] text-court font-bold text-sm mb-4">
            {ATLETICA.kicker}
          </p>
          <h2 className="font-heading uppercase leading-[0.9] text-navy text-4xl md:text-6xl tracking-tight">
            {ATLETICA.title}
          </h2>
        </Reveal>
      </div>

      <Reveal y={50}>
        <div className="relative border-4 border-navy shadow-hard overflow-hidden mb-14">
          <img
            src={ATLETICA.image}
            alt="Partenza del Cross delle Colline Moreniche di Tricesimo"
            className="w-full h-72 md:h-[520px] object-cover block"
            data-testid="atletica-img"
          />
          <div className="absolute bottom-0 left-0 bg-navy text-gold font-heading uppercase text-lg md:text-2xl px-5 py-2">
            Cross delle Colline Moreniche
          </div>
        </div>
      </Reveal>

      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
        {/* Intro / lead */}
        <div className="lg:col-span-4">
          <Reveal>
            <div className="lg:sticky lg:top-28 space-y-5 border-l-4 border-court pl-6">
              {ATLETICA.intro.map((p, i) => (
                <p
                  key={i}
                  className={`font-body leading-relaxed ${i === 0 ? "text-navy text-lg md:text-xl font-600" : "text-navy/70 text-base"}`}
                >
                  {p}
                </p>
              ))}
            </div>
          </Reveal>
        </div>

        {/* Chapters */}
        <div className="lg:col-span-8 space-y-12">
          {ATLETICA.chapters.map((ch, ci) => (
            <Reveal key={ch.title} delay={0.04 * ci}>
              <article data-testid={`atletica-chapter-${ci}`}>
                <div className="flex items-baseline gap-4 mb-4">
                  <span className="font-heading text-court text-2xl md:text-3xl leading-none">
                    {String(ci + 1).padStart(2, "0")}
                  </span>
                  <h3 className="font-sub uppercase font-bold tracking-wide text-navy text-xl md:text-2xl">
                    {ch.title}
                  </h3>
                </div>
                <div className="space-y-4 md:pl-12">
                  {ch.paragraphs.map((p, pi) => (
                    <p key={pi} className="font-body text-navy/75 text-base md:text-lg leading-relaxed">
                      {p}
                    </p>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}

          {/* Dedica */}
          <Reveal>
            <div
              data-testid="atletica-dedica"
              className="bg-navy text-white border-4 border-navy shadow-hard-orange p-8 md:p-10 flex flex-col md:flex-row items-start gap-6"
            >
              <div className="shrink-0 bg-court text-white w-14 h-14 flex items-center justify-center">
                <Heart size={28} />
              </div>
              <div>
                <h3 className="font-heading uppercase text-2xl md:text-3xl text-gold mb-3">
                  {ATLETICA.dedica.title}
                </h3>
                <p className="font-body text-white/80 text-base md:text-lg leading-relaxed">
                  {ATLETICA.dedica.text}
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Atletica;
